import _ from 'lodash';
import tokenStore from "../../authentication/tokenStore";
import {TokenDetails} from "../../authentication/TokenTypes";

class CredentialsUpdateService {
  isForceCredentialsUpdate(): boolean {
    const tokenDetails: TokenDetails = tokenStore.getTokenDetails();

    // Early return if force update is not enabled
    if (tokenDetails?.forcePasswordUpdate === false && tokenDetails?.forcePinUpdate === false) {
      return false;
    }

    const permissionsArray = Object.keys(tokenDetails.permissions);
    const forcedCredentialsUpdatePermissions = ['MNG_PASSWORD_WRITE', 'MNG_PIN_WRITE'];
    const loginBasicPermissions = ['MNG_ROLE_ACCESS_RULES', 'MNG_ROLE_COMMAND_ACCESS','MNG_READ_USER_DETAILS','MNG_BRANCH_READ'];

    const missingRequiredForceUpdatePermissions = _.difference(forcedCredentialsUpdatePermissions, permissionsArray);
    const missingLoginBasicPermissions = _.difference(loginBasicPermissions, permissionsArray);

    const noMissingLoginBasicPermission = missingLoginBasicPermissions.length === 0;
    const hasAtleastOneUpdateCredentialsPermission = missingRequiredForceUpdatePermissions.length <= 1;

    return  hasAtleastOneUpdateCredentialsPermission && noMissingLoginBasicPermission;
  }

  getRedirectUrl(): string {
    const tokenDetails: TokenDetails = tokenStore.getTokenDetails();
    return `/admin/organization/users/${tokenDetails.userBranchId}`
      + `/user/${tokenDetails.userId}/credentials-update?showPasswordTab=true`;
  }
}

export default CredentialsUpdateService;